<template>
	<div class="home">
		<h1 class="font-weight-light text-primary">Current jobs</h1>
		<CurrentJobs />
	</div>
</template>

<script>
import CurrentJobs from '../components/CurrentJobs.vue'

export default {
	name: 'home',
	components: {
		CurrentJobs
	}
}
</script>
